import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export const PoemQuote = () => {
  const { t } = useLang();
  return (
    <section data-testid="poem-section" className="py-24 sm:py-36 px-5 text-center bg-[#faf9f6]">
      <div className="max-w-3xl mx-auto">
        {t.poem.lines.map((line, i) => (
          <motion.p
            key={i}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.18 }}
            className="font-display italic text-2xl sm:text-4xl leading-snug text-neutral-800"
          >
            {line}
          </motion.p>
        ))}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mt-8 font-tech text-[11px] tracking-[0.35em] uppercase text-neutral-400"
        >
          — {t.poem.author}
        </motion.p>
      </div>
    </section>
  );
};
